
import { computed, defineComponent, reactive, toRaw, onBeforeMount, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useVuelidate } from '@vuelidate/core'
import { email, required, helpers } from '@vuelidate/validators'
import { useAuth } from '@/composables/firebase/useAuth'
// import SocialLoginButton from '../components/auth/SocialLoginButton.vue'
import BaseInput from '@/components/base/BaseInput.vue'
import LanguageSelect from '@/components/settings/languageSelect.vue'
import { useI18n } from 'vue-i18n'
import { useAxios } from '@/composables/useAxios'

export default defineComponent({
  components: {
    BaseInput,
    LanguageSelect
  },
  setup () {
    const isEmailSended = ref(false)

    const { t } = useI18n()

    const {
      loginWithLinkToEmail,
      loginWithCustomToken
    } = useAuth()

    const isUsingCustomToken = ref(false)
    const isCustomTokenFailed = ref(false)

    const form = reactive({
      email: '',
    })

    const rules = {
      email: {
        required: helpers.withMessage(t('validations.required'), required),
        email: helpers.withMessage(t('validations.email'), email),
      }
    }

    const v$ = useVuelidate(rules, form)

    const isSubmitDisabled = computed(() => {
      return v$.value.$invalid
    })

    const emailErrorMessage = computed(() => v$.value.email.$errors[0]?.$message)

    const login = async () => {
      if (!isSubmitDisabled.value) {
        isEmailSended.value = await loginWithLinkToEmail(toRaw(form))
      }
    }

    async function attemptLoginWithCustomToken (token: string, otp: string) {
      isUsingCustomToken.value = true

      const { httpFunctions } = await useAxios()

      try {
        const { data } = await httpFunctions.get('/api/auth', {
          params: { token, otp }
        })

        await loginWithCustomToken(data.token)
      } catch (error) {
        isCustomTokenFailed.value = true
        console.error(error)
      }
    }

    onBeforeMount(async () => {
      const router = useRouter()
      const { token, otp } = router.currentRoute.value.query

      if (typeof token === 'string' && typeof otp === 'string') {
        await attemptLoginWithCustomToken(token, otp)
      }
    })

    return {
      isEmailSended,
      emailErrorMessage,
      form,
      login,
      isSubmitDisabled,
      isUsingCustomToken,
      isCustomTokenFailed,
      v$,
    }
  }
})
